import {
	Disclosure as AriaDisclosure,
	DisclosurePanel as AriaDisclosurePanel,
} from "react-aria-components";
import { CONFIG } from "../../config";
import { tw } from "../../styling";

export type Speed = "fast" | "default";

type Props = {
	children: React.ReactNode;
	isExpanded: boolean;
	headingId?: string;
	contentId?: string;
	speed?: Speed;
};

// eslint-disable-next-line tailwindcss/no-arbitrary-value
const styles = tw`h-(--disclosure-panel-height) overflow-hidden transition-[height] ease-in-out print:h-auto! print:overflow-visible!`;

export const Expandable = ({
	isExpanded,
	children,
	headingId,
	contentId,
	speed = "default",
}: Props) => {
	// todo: vilket av dessa ska det vara egentligen?
	const isTest = import.meta.env.MODE === "test" || CONFIG.IS_TEST === true;

	if (isTest) {
		return isExpanded ? <div>{children}</div> : null;
	}

	const speeds: Record<Speed, string> = {
		fast: "duration-250",
		default: "duration-850",
	};

	return (
		<AriaDisclosure isExpanded={isExpanded}>
			<AriaDisclosurePanel
				aria-labelledby={headingId}
				id={contentId}
				role="region"
				className={tw(styles, speeds[speed])}
			>
				{children}
			</AriaDisclosurePanel>
		</AriaDisclosure>
	);
};
